export default function validate(values, required) {
  let errors = {};

  if (required.first_name && !values.first_name) {
    errors.first_name = 'First name is required';
  }

  if (required.last_name && !values.last_name) {
    errors.last_name = 'Last name is required';
  }
  
  if (required.phone && !values.phone) {
    errors.phone = 'Phone is required';
  }

  if (required.email) {
    if (!values.email) {
      errors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Email address is not valid';
    }
  }
  
  if (required.password && !values.password) {
    errors.password = 'Password is required';
  }

  if (required.address && !values.address) {
    errors.address = 'Address is required';
  }

  if (required.city && !values.city) {
    errors.city = 'City is required';
  }

  if (required.state && !values.state) {
    errors.state = 'Choose a state';
  }

  if (required.zipcode && !values.zipcode) {
    errors.zipcode = 'Zipcode is required';
  }

  if (required.acceptTerms && values.acceptTerms !== true) {
    errors.acceptTerms = 'Accept terms and conditions';
  }

  return errors;
}